import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'

import { hiddenInPaging } from '../../../functions'

import RangeForm from '../forms/range-form'
import SelectForm from '../forms/select-form'

class TableItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false,
      showSelectForm: false,
      focusMemberSelector: false,
      preventFaderUpdates: false
    }
  }

  renderDropdown(item) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showSelectForm: true, showDropdown: false})}>Change monitor</li>
              {
                item.member || item.value
                ? <li onClick={() => this.setState({showDropdown: false}, () => this.props.editRiderItem({id: item.id, member: null, value: null}))}>Remove {(item.member && item.member.name) || item.value} from this monitor</li>
                : <li onClick={() => this.setState({showSelectForm: true, focusMemberSelector: true, showDropdown: false})}>Assign a member</li>
              }
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderItem(item.id))}>Remove this monitor</li>
            </ul>
          : null
        }
      </div>
    )
  }

  itemIsSelected(selectedItem) {
    const { item } = this.props
    const isStereo = selectedItem.type && selectedItem.type.includes('stereo')

    if (item.id) {
      if (isStereo) {
        this.setState({preventFaderUpdates: true}, () => this.props.cloneRiderItem({...item, title: selectedItem.title, type: selectedItem.type}))
      } else {
        this.props.editRiderItem({...selectedItem, id: item.id})
      }
    } else {
      if (isStereo) {
        this.props.createRiderItems(selectedItem)
      } else {
        this.props.createRiderItem({...selectedItem, class: 'monitor'})
      }
    }
  }

  renderEmptyTableItem() {
    const { item, value, itemTypes, members, paging } = this.props

    return (
      <div className="table-item table-item--empty" style={{minWidth: `${100/paging.size}%`, maxWidth: `${100/paging.size}%`}}>
        <div className="table-item-handle" />

        <div className="table-item-head">
          <div className="table-item-channel">
            {item.channel}
          </div>

          <SelectForm
            item={item}
            value={value}
            itemTypes={itemTypes}
            members={members}
            onItemSelect={(selectedItem) => this.itemIsSelected(selectedItem)}
            removeFocus={() => this.props.removeRiderItem(item)} />
        </div>
      </div>
    )
  }

  renderTableItem() {
    const { view, item, value, itemTypes, members, paging } = this.props
    const { faders } = item
    const { showSelectForm, focusMemberSelector, preventFaderUpdates } = this.state

    return (
      <Draggable draggableId={item.id} isDragDisabled={true} type="item">
        {(provided, snapshot) => (
          <div className="table-item" style={{minWidth: `${100/paging.size}%`, maxWidth: `${100/paging.size}%`}}>
            <div className="table-item--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle}
              {...provided.dragHandleProps} >
              <div className="table-item-handle" />

              <div className="table-item-head">
                {
                  view.editable
                  ? this.renderDropdown(item)
                  : null
                }

                <div className="table-item-channel">
                  {item.channel}
                </div>

                {
                  showSelectForm
                  ? <SelectForm
                      item={item}
                      value={value}
                      itemTypes={[...itemTypes, {class: 'monitor', type: null, title: 'Assign member'}]}
                      members={members}
                      focusMemberSelector={focusMemberSelector}
                      onItemSelect={(selectedItem) => this.setState({showSelectForm: false, focusMemberSelector: false}, () => this.itemIsSelected(selectedItem))}
                      removeFocus={() => this.setState({showSelectForm: false, focusMemberSelector: false})} />
                  : <div className="name" onClick={() => this.setState({showSelectForm: true})}>{value}</div>
                }
              </div>

              {
                faders && faders.length > 0
                ? <div className="table-item-body table-item-body--output">
                    {
                      faders.map((fader, index) => {
                        return (
                          <RangeForm key={index}
                            view={view}
                            child={fader}
                            value={parseInt(fader.value, 10)}
                            createRiderItem={(item) => preventFaderUpdates !== true ? this.props.createRiderItem(item) : null}
                            editRiderItem={(item) => preventFaderUpdates !== true ? this.props.editRiderItem(item) : null} />
                        )
                      })
                    }
                  </div>
                : null
              }
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const { item, itemIndex, paging } = this.props

    if (hiddenInPaging(paging, itemIndex)) return null

    return item.id
    ? this.renderTableItem()
    : this.renderEmptyTableItem()
  }
}

TableItem.propTypes = {
  view: PropTypes.object,
  value: PropTypes.string,
  item: PropTypes.object,
  itemIndex: PropTypes.number,
  itemTypes: PropTypes.array,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  cloneRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  members: PropTypes.array,
  paging: PropTypes.object
}

TableItem.defaultProps = {
  view: {},
  value: '',
  item: {},
  itemIndex: 0,
  itemTypes: [],
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  cloneRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  members: [],
  paging: {}
}

export default TableItem



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output-table/table-item.js